import { createFileRoute, redirect } from '@tanstack/react-router'

/** /admin no tiene contenido propio: entra directo a la primera pestaña. */
export const Route = createFileRoute('/_protected/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/cargas' })
  },
})
